import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DrawdownPriceLockModel } from '../../Models/Models/QuoteAndApplyBase/Shared/DrawdownPriceLockModel';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class DrawdownPriceLockClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(subAccountHierarchyId: string): Promise<DrawdownPriceLockModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/DrawdownPriceLock/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.get<DrawdownPriceLockModel, any>(url, data);
  }
  public put(hierarchyId: string, usePriceLock: boolean): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/DrawdownPriceLock/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, usePriceLock: usePriceLock }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
}

